import { DialogComponentContent } from './../../../models/dialogs/DialogComponentContent';
import { Component, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'pr-rescue',
    templateUrl: './pr-rescue.component.html',
    styleUrls: ['./pr-rescue.component.scss'],
})
export class PrRescueComponent extends DialogComponentContent {

    constructor(
        public dialogRef: MatDialogRef<PrRescueComponent>,
        element: ElementRef,
    ) {
        super(element);
     }

    public dispose() {
        this.dialogRef.close();
    }
}
